module.exports = __webpack_public_path__ + "img/flight.519d3787.png";